export default attendeeId => {
  return (_, getState, socket) => {
    const { broadcast } = getState();

    // Notify the attendee to leave the meeting via socket
    socket.emit('attendeeDismiss', {
      broadcastId: broadcast._id,
      attendeeId
    });
  };
};
